/* ============================================================
   AlienGrafic · Confirmación "✓ Agregado" en la cuadrícula
   ------------------------------------------------------------
   NO toma el control ni busca la variante. Deja que Dawn agregue
   (su request a /cart/add) y solo detecta cuándo termina, para
   mostrar "✓ Agregado" verde en el botón que se clickeó.

   Detecta el agregado envolviendo fetch Y XMLHttpRequest, así
   funciona sea cual sea la vía que use tu versión de Dawn.
   ============================================================ */
(function () {
  var ADDED_MS = 1500;
  var pending = null;   // botón del último click de añadido rápido

  // 1) Recordar qué botón se clickeó (sin frenar nada)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#product-grid .quick-add__submit');
    if (!btn) return;
    if (btn.getAttribute('aria-haspopup') === 'dialog') return; // "Elegir opciones"
    pending = btn;
  }, true);

  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  function confirmAdd() {
    if (!pending) return;
    var btn = pending;
    pending = null;
    showAdded(btn);
  }

  // 2a) Interceptar fetch (Dawn moderno)
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var arg = arguments[0];
      var url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      var p = origFetch.apply(this, arguments);
      if (isCartAdd(url)) {
        p.then(function (res) { if (res && res.ok) confirmAdd(); }).catch(function () {});
      }
      return p;
    };
  }

  // 2b) Interceptar XMLHttpRequest (por si tu Dawn usa XHR)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartAdd = isCartAdd(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) confirmAdd();
      });
    }
    return origSend.apply(this, arguments);
  };

  function showAdded(btn) {
    var label = btn.querySelector('span') || btn;
    var original = label.textContent;
    btn.classList.add('is-added');
    label.textContent = '✓ Agregado';
    setTimeout(function () {
      btn.classList.remove('is-added');
      label.textContent = original;
    }, ADDED_MS);
  }
})();